import * as React from 'react';

import { INewbuildingSummaryCellValue } from '../../types/newbuildingsCompare';
import { NewbuildingCallButton } from '../NewbuildingCallButton';
import { TSellerType } from '../NewbuildingCallButton/tracking';
import { NewbuildingChatButton } from '../NewbuildingChatButton';
import { NewbuildingFavoriteButton } from '../NewbuildingFavoriteButton';
import { Header } from '../../components/FullScreenGallery/Header';

export interface IGalleryHeaderContainerProps {
  newbuilding?: INewbuildingSummaryCellValue;
  onClose(): void;
}

export function GalleryHeaderContainer({ newbuilding, onClose }: IGalleryHeaderContainerProps): React.JSX.Element {
  const hasChat = Boolean(
    newbuilding && [...newbuilding.builders, ...newbuilding.sellers].some(contact => contact.chat?.enabled),
  );

  const sellerType: TSellerType = newbuilding && newbuilding.builders.length > 0 ? 'builders' : 'agents';

  return (
    <Header
      call={
        newbuilding && (
          <NewbuildingCallButton
            builders={newbuilding.builders}
            newbuildingId={newbuilding.id}
            sellers={newbuilding.sellers}
            size="M"
            singlePhoneButtonText="Контакты застройщика"
            url={newbuilding.fullUrl}
            showPhoneButtonIcon={true}
          />
        )
      }
      favorite={
        newbuilding && (
          <NewbuildingFavoriteButton
            gaLabel={newbuilding.fullUrl}
            isFavorite={newbuilding.isFavorite}
            newbuildingId={newbuilding.id}
            sellerType={sellerType}
            url={newbuilding.fullUrl}
            variant="button"
          />
        )
      }
      chat={
        hasChat &&
        newbuilding && (
          <NewbuildingChatButton
            builders={newbuilding.builders}
            newbuildingId={newbuilding.id}
            sellers={newbuilding.sellers}
            size="M"
            url={newbuilding.fullUrl}
          />
        )
      }
      name={newbuilding?.name}
      onClose={onClose}
    />
  );
}
